/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import {
    object, func, shape, string, bool, array, number,
} from 'prop-types';
import ReactHTMLParser from 'react-html-parser';
import ChatDialog from './ChatDialog';
import formatTimeAgo from '../utils/timeAgo';
import ResponsiveImageOrSvg from './ResponsiveImageOrSvg';
import ResponsiveImage from '../../GraphqlComponents/GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';
import imagesConstantArray from './chatIcons';

const ChatSelectDialog = ({
    onSubmitMessage,
    interactiveData,
    messageObj,
    messageParsedTitle,
    classList,
    lastMessageIndex,
    timeAgo,
}) => {
    const [showDialog, setShowDialog] = useState(false);
    const toggleDialog = () => setShowDialog((status) => !status);
    const {
        timeStyles,
        bubble,
        bubbleLeft,
        bubbleMessage,
        leftBubbleMessage,
        selBubble,
        selOptLink,
        selOptLinkSpan,
        selOptLinkSubtitle,
        selOptLinkTitle,
        selectedBubble,
        selectedBubbleImg,
        selfMessage,
        listItem,
        listItemName,
        listItemSubTitle,
        listItemTitle,
        itemImg,
        itemImgSvg,
        bold,
        checkIcon,
    } = classList;
    /**
     * returns the image key/value pair that matches the provided key
     * which is the name and extension of the image
     * @param {*} keyTofind
     */
    const getSVGByKey = (keyTofind) => imagesConstantArray.find((image) => image?.imageKey?.toLowerCase() === keyTofind?.toLowerCase());

    /**
     * returns the object from the array of images that contains the path to the key
     * which is the main image that should be shown on a list picker
     * @param {*} keyTofind
     */
    const getMainListPickerImageKey = (imgIdentifier, imgList) => imgList.find((element) => element.identifier === imgIdentifier);

    const mainListImageKey = getMainListPickerImageKey(interactiveData?.receivedMessage?.imageIdentifier, interactiveData?.data?.images)?.data;
    return (
        <div>
            {messageObj?.disable
                ? (
                    <div>
                        <div className={`${bubble} ${bubbleLeft}`}>
                            <div className={selectedBubble}>
                                <ResponsiveImage
                                    alt=""
                                    path="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltb77509bc7cfa5b90/6054b8565a03370f176cc97e/circle-check.svg"
                                    className={selectedBubbleImg}
                                    params={{ desktop: 'quality=100', mobile: 'quality=100' }}
                                />
                                <div>{ReactHTMLParser(messageObj?.selectedItem?.title)}</div>
                            </div>
                        </div>
                        <div className={`${bubble} ${selfMessage}`}>
                            <div className={`${bubbleMessage}`}>
                                <div className={`${listItem}`} id="listitem2">
                                    <ResponsiveImageOrSvg
                                        dynamicIcon={messageObj?.selectedItem?.selectedImage}
                                        responsiveImageClassName={itemImg}
                                        svgClassName={itemImgSvg}
                                    />
                                    <div className={listItemName}>
                                        <span className={`${listItemTitle} ${messageObj?.selectedItem?.subtitle ? bold : ''}`}>
                                            {messageParsedTitle}
                                        </span>
                                        {messageObj?.selectedItem?.subtitle && <br />}
                                        <span className={listItemSubTitle}>{messageObj?.selectedItem?.subtitle}</span>
                                        <span />
                                    </div>
                                </div>
                                <span className={checkIcon} />
                                {
                                    lastMessageIndex?.responseMessage?.o === messageObj?.responseMessage?.o
                                        ? (
                                            <span className={timeStyles} style={{ padding: 0, float: 'right' }}>
                                                {formatTimeAgo(timeAgo, true)}
                                            </span>
                                        ) : ''
                                }
                            </div>
                        </div>
                    </div>
                )
                : (
                    <div className={`${bubble} ${bubbleLeft}`}>
                        <div className={`${bubbleMessage} ${leftBubbleMessage} ${selBubble}`}>
                            <button
                                type="button"
                                className={selOptLink}
                                onClick={toggleDialog}
                                data-testid="toggle-dialog"
                            >
                                <span className={selOptLinkSpan}>
                                    <span className={selOptLinkTitle}>{ReactHTMLParser(interactiveData?.receivedMessage?.title)}</span>
                                    <span className={selOptLinkSubtitle}>{interactiveData?.receivedMessage?.subtitle}</span>
                                </span>
                                <ResponsiveImageOrSvg
                                    dynamicIcon={
                                        mainListImageKey?.startsWith('https')
                                            ? mainListImageKey
                                            : getSVGByKey(mainListImageKey?.split('/')[2] || mainListImageKey)?.imageValue
                                    }
                                    responsiveImageClassName={`ml-4 ${itemImg}`}
                                />
                            </button>
                            {lastMessageIndex?.responseMessage?.o === messageObj?.responseMessage?.o
                                ? (
                                    <span className={timeStyles} style={{ padding: '15px 0px 0px' }}>
                                        {formatTimeAgo(timeAgo, false)}
                                    </span>
                                )
                                : ''}
                        </div>
                    </div>
                )}
            {showDialog && (
                <ChatDialog
                    onSubmitMessage={onSubmitMessage}
                    showDialog={showDialog}
                    getSVGByKey={getSVGByKey}
                    interactiveData={interactiveData}
                    closeDialog={toggleDialog}
                    messageObj={messageObj}
                    data-testid="chat-dialog"
                />
            )}
        </div>
    );
};

ChatSelectDialog.propTypes = {
    interactiveData: object.isRequired,
    messageObj: shape({
        userName: string,
        responseMessage: object,
        msgType: string.isRequired,
        disable: bool.isRequired,
    }).isRequired,
    messageParsedTitle: array.isRequired,
    classList: object.isRequired,
    lastMessageIndex: object,
    timeAgo: number.isRequired,
    // functions
    onSubmitMessage: func.isRequired,
};
ChatSelectDialog.defaultProps = {
    lastMessageIndex: {},
};

export default ChatSelectDialog;
